"use client";
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import DeliveryDateSelector from "../../../molecules/deliveryDateSelector";
import { shallowEqual, useSelector } from "react-redux";
import CustomImage from "../../../atoms/customImage";
import { renderDateString } from "../../../../utils/pdp/common";
import { SELECT_DELIVERY_DATE } from "../../../../constants/common/common";

/** */
const DeliveryDateSelectorButton = ({
  selectedDate,
  setSelectedDate,
  currentItem,
  onHandlePopOverVisibility,
  setHasTimeSlot,
  isCourier,
  isCart,
}) => {
  const { deliveryDates, selectedDeliveryDetails, isCartVisible } = useSelector(
    (state) => ({
      deliveryDates: state?.shippingDateAndSlotSelection?.deliveryDates,
      selectedDeliveryDetails: state?.shippingDateAndSlotSelection?.selectedDeliveryDetails,
      isCartVisible: state?.cart?.isCartVisible,
    }),
    shallowEqual,
  );

  useEffect(() => {
    if (!isCourier) {
      if (deliveryDates && !isCartVisible) {
        const earliestDateAvailable = deliveryDates?.deliveryDates?.[0];
        setSelectedDate(earliestDateAvailable);
      }
    } else if (!isCart) {
      setSelectedDate(selectedDeliveryDetails?.selectedDate || "");
    }
  }, [deliveryDates]);

  useEffect(() => {
    setHasTimeSlot(true);
  }, []);

  return (
    <div className={`${isCart ? "px-5" : ""}`}>
      <DeliveryDateSelector
        onClickHandler={onHandlePopOverVisibility}
        value={
          renderDateString(selectedDate, currentItem, [], false, false)
            ? renderDateString(selectedDate, currentItem, [], false, false)
            : SELECT_DELIVERY_DATE
        }
        errorStyleType="animate"
        startAdornment={
          <CustomImage src={`/icons/calender-icon.svg`} width={24} height={24} alt="email icon" sizes="10vw" />
        }
        endAdornment={
          <CustomImage src={"/icons/arrow-right-gray.svg"} width={16} height={16} alt="email icon" sizes="10vw" />
        }
      />
    </div>
  );
};

DeliveryDateSelectorButton.propTypes = {
  selectedDate: PropTypes.string,
  currentItem: PropTypes.object,
  onHandlePopOverVisibility: PropTypes.func,
  setSelectedDate: PropTypes.func,
  setHasTimeSlot: PropTypes.func,
  isCourier: PropTypes.bool,
  isCart: PropTypes.bool,
};

export default DeliveryDateSelectorButton;
